import React, { useEffect, useState } from 'react';
import './PermitViewPage.css';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import { Button, Form, Input, Checkbox, FloatButton, Tooltip, TimePicker, Switch, Upload, Select, Tabs, Steps } from "antd";
import { LeftOutlined, UploadOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useForm } from "antd/es/form/Form";
import Loader from "../../Components/Loader/Loader";
import { usePermitStore } from "../../Store/store";
import { toast } from "react-toastify";
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { format, parseISO } from "date-fns";
import { isTimeInRange } from "../../Pages/PermitViewPage/utils"
import { useGetPermitByBasicIDQuery } from '../../services/query';
import { useQueryClient } from '@tanstack/react-query';
const { TabPane } = Tabs;
const { Step } = Steps;

const PermitViewPage = () => {
    const { state, pathname } = useLocation();
    const Navigate = useNavigate();
    const [PermitBasicInsertForm] = useForm();
    const [PermiMasterInsertForm] = useForm();
    const [ApproveCommentsForm] = useForm();
    const [ExtensionCommentsForm] = useForm();
    const [ExtentionInsertForm] = useForm();
    const [PermitCloceForm] = useForm();
    const [LoginInfo, setLoginInfo] = useState();
    const ExportBasicDetail = usePermitStore((state) => state.ExportBasicDetail);
    const ExportExtentionDetail = usePermitStore((state) => state.ExportExtentionDetail);
    const ExportPermitImgDetail = usePermitStore((state) => state.ExportPermitImgDetail);
    const ExportPermitActivity = usePermitStore((state) => state.ExportPermitActivity)
    const ExportPermitApproval = usePermitStore((state) => state.ExportPermitApproval)
    const [PermitImageDatas, setPermitImageDatas] = useState([])
    const [PermitFileImage, setPermitFileImage] = useState([])
    const [PermitMasterData, setPermitMasterData] = useState([])
    const [LoaderHiden, setLoaderHiden] = useState(false)
    const [ExtentionView, setExtentionView] = useState(false)
    const [visibleDialog, setVisibleDialog] = useState(false);
    const [visibleExtensionDialog, setVisibleExtensionDialog] = useState(false);
    const [closePermitDialog, setClosePermitDialog] = useState(false)
    const [ApproveRejectStatus, setApproveRejectStatus] = useState("");
    const [ApproveExtensionStatus, setApproveExtensionStatus] = useState("");
    const [isButtonVisible, setIsButtonVisible] = useState(false);
    const [FileLists, setFileList] = useState([]);
    const [ViewActiveIcon, setViewActiveIcon] = useState(false);
    const { TextArea } = Input;
    const permitStore = usePermitStore((state) => state)
    const [inputValue, setInputValue] = useState('');
    const { data: permiData } = useGetPermitByBasicIDQuery({ BasicDetailID: state.basicDetailID });
    const queryClient = useQueryClient();

    useEffect(() => {
        queryClient.invalidateQueries({ queryKey: ["GetPermitByBasicID"] });
    }, [])

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };
    const handleSubmit = () => {
        let value = {};
        value.basicDetailID = ExportBasicDetail.basicDetailID;
        value.content = inputValue;
        value.empId = LoginInfo.employeeId
        let URL = process.env.REACT_APP_PERMIT + "/Master/CreateCommentsBasedonBasicId"
        axios.post(URL, value).then((Res) => {
            if (Res.status === 200) {
                queryClient.invalidateQueries({ queryKey: ["GetPermitByBasicID"] });
                setInputValue('');
                toast.success("Comments Added Successfully")
            }
        }).catch((Error) => {
            console.log(Error, "Error GetNatureofwork")
        })
    };
    useEffect(() => {
        const checkTime = () => {
            const visible = isTimeInRange(16, 0, 17, 0); // 4:30 PM to 5:00 PM
            setIsButtonVisible(visible);
        };
        checkTime();
        const intervalId = setInterval(checkTime, 60 * 1000);
        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        setLoginInfo(JSON.parse(sessionStorage.getItem("UserInfo")))
    }, []);

    useEffect(() => {
        if (permiData !== undefined && Object.keys(permiData).length > 0) {
            let basicDetail = permiData?.basicDetails
            if (basicDetail && Object.keys(basicDetail).length > 0) {
                permitStore.setExportBasicDetail(basicDetail);
            }
            let ExtentionDetail = permiData?.extensiondatetime
            if (ExtentionDetail) {
                permitStore.setExportExtentionDetail(ExtentionDetail)
            } else {
                permitStore.setExportExtentionDetail(undefined)
            }
            let PermitDetails = permiData?.permitDetails
            if (PermitDetails) {
                permitStore.setExportPermitImgDetails(PermitDetails)
                if (PermitDetails?.images?.length > 0) {
                    getPermitPlaceImage(PermitDetails?.images)
                } else {
                    setPermitImageDatas([])
                }
            } else {
                permitStore.setExportPermitImgDetails(undefined)
            }
            let permitImages = permiData?.permitImages
            if (permitImages) {
                permitStore.setExportPermitImages(permitImages)
                if (permitImages?.images?.length > 0) {
                    getPermitFileImage(permitImages?.images)
                } else {
                    setPermitFileImage([])
                }
            } else {
                permitStore.setExportPermitImages([])
            }

            if (permiData?.activities?.length > 0) {
                permitStore.setPermitActivity(permiData?.activities)
            } else {
                permitStore.setPermitActivity([])
            }
            if (permiData?.permitApproval?.length > 0) {
                permitStore.setPermitApproval(permiData?.permitApproval)
            } else {
                permitStore.setPermitApproval([])
            }
            if (permiData?.permitparent?.length > 0) {
                permitStore.setExportPermitDetail(permiData?.permitparent)
                var permit = permiData?.permitparent?.map(item => {
                    if (item.type === "bool") {
                        item.value = item?.value?.toString()?.toLowerCase() === "false" ? false : true;
                    }
                    if (item.children && item?.children?.length > 0) {
                        item.children.forEach(child => {
                            if (child.type === "bool") {

                                child.value = child?.value?.toString()?.toLowerCase() === "false" ? false : true;
                            }
                        });
                    }
                    return item;
                })
                setPermitMasterData(permit)
            }
        }
    }, [permiData]);

    const getPermitPlaceImage = (data) => {
        let Image = [];
        Image = data
        let URL = process.env.REACT_APP_PERMIT + "/Master/DownloadImage"
        axios.post(URL, Image).then((Response) => {
            setPermitImageDatas(Response.data)
            Image = []
        })
    }

    const getPermitFileImage = (data) => {
        let Image = [];
        Image = data
        let URL = process.env.REACT_APP_PERMIT + "/Master/DownloadImage"
        axios.post(URL, Image).then((Response) => {
            setPermitFileImage(Response.data)
            Image = []
        })
    }

    const RevertViewPermit = () => {
        PermitBasicInsertForm.resetFields()
        PermiMasterInsertForm.resetFields()
        setPermitMasterData("")
        Navigate("/BasicPermit");

    }

    const RevertViewApproval = () => {
        PermitBasicInsertForm.resetFields()
        PermiMasterInsertForm.resetFields()
        setPermitMasterData("")
        Navigate("/ViewApprovalPage");
    }

    const RevertExtensionApproval = () => {
        PermitBasicInsertForm.resetFields()
        PermiMasterInsertForm.resetFields()
        setPermitMasterData("")
        Navigate("/ExtensionApprovalPage");
    }
    const ClosePermitStatus = () => {
        setClosePermitDialog(true)
    }

    const permitCloseDialog = () => {
        setClosePermitDialog(!closePermitDialog);
    }

    const ViewExportToPermit = () => {
        Navigate("/ExportSheete");
    }

    const ViewExtentionPage = () => {
        setExtentionView(true)
    }

    const BackToEntention = () => {
        ExtentionInsertForm.resetFields()
        setExtentionView(false)
    }
    const onFileUplode = async (file) => {
        if (file.fileList.length > 0) {
            let base64Image = await getBase64(file.file.originFileObj)
            let fileName = file.file.name
            setFileList([...FileLists, {
                uid: file.uid,
                name: fileName,
                status: 'done',
                url: base64Image,
            }])
        }
        else {
            setFileList([])
        }
    }

    const groupedData = ExportPermitApproval.reduce((acc, item) => {
        if (!acc[item.approvalType]) {
            acc[item.approvalType] = [];
        }
        acc[item.approvalType].push(item);
        return acc;
    }, {});


    const getBase64 = (FileLists) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(FileLists);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const onRemoveFile = (file) => {
        setFileList((prevFileList) => prevFileList.filter((item) => item.uid !== file.uid));
        PermitCloceForm.setFieldValue((prevFileList) => prevFileList.filter((item) => item.uid !== file.uid))
        return true;
    }

    const ClosePermitRequest = async () => {
        setLoaderHiden(true);
        let ClosePermitDetail = {}
        let AttachInputs = [];
        for (const FileList of FileLists) {
            let InputData = {};
            InputData.base64 = FileList.url?.split("base64,")[1];
            InputData.fileName = FileList.name;
            AttachInputs.push(InputData);
        }
        ClosePermitDetail.empID = LoginInfo.employeeId;
        ClosePermitDetail.permitNumber = ExportPermitImgDetail.permitNumber;
        ClosePermitDetail.basicDetailID = ExportBasicDetail.basicDetailID;
        ClosePermitDetail.images = AttachInputs
        let URL = process.env.REACT_APP_PERMIT + "/Master/UpdateImage"
        await axios.put(URL, ClosePermitDetail).then((res) => {
            if (res.status === 200) {
                setLoaderHiden(false)
                setClosePermitDialog(false)
                PermitCloceForm.resetFields()
                toast.success("Permit Closed Successfully")
                Navigate("/BasicPermit");
            } else {
                setLoaderHiden(false)
                toast.error(res.data)
            }
        }).catch((Error) => {
            setLoaderHiden(false)
            console.log(Error, "Error Insert_PRRequest")
        })
    };

    const ExtentionInsert = () => {
        setLoaderHiden(true)
        let Input = {}
        Input = ExtentionInsertForm.getFieldsValue()
        let Input_Value = {
            extensionDateTime: new Date(Input.AddEntentionTime.$d),
            departmentID: ExportBasicDetail.departmentID,
            permitNumber: ExportPermitImgDetail.permitNumber,
            empid: LoginInfo.employeeId,
            basicID: ExportBasicDetail.basicDetailID

        }
        let URL = process.env.REACT_APP_PERMIT + "/Master/CreateExtensionByPermitNum"
        // console.log(Input_Value, "Input_Value")
        axios.post(URL, Input_Value).then((Res) => {
            if (Res.status === 200) {
                setLoaderHiden(false)
                toast.success(Res.data)
                window.location.reload();
            } else {
                setLoaderHiden(false);
                toast.error(Res.data)
            }
        }).catch((Error) => {
            console.log(Error, "Error GetNatureofwork")
        })
    };

    const ApproveRejectSubmit = (data) => {
        setApproveRejectStatus(data)
        setVisibleDialog(!visibleDialog);
    }

    const ExtensionApproveSubmit = (data) => {
        setApproveExtensionStatus(data)
        setVisibleExtensionDialog(!visibleDialog);
    }

    const getDisabledHours = () => {
        var hours = [];
        for (let i = 0; i < moment().hour(); i++) {
            hours.push(i);
        }
        return hours;
    }

    const ApproveComment = () => {
        setLoaderHiden(true);
        let permitNumber = "";
        permitNumber = ExportPermitImgDetail.permitNumber;
        let Inputs = {}
        Inputs = ApproveCommentsForm.getFieldsValue()
        let data = {
            approverLevel: state.approvalLevel,
            remarks: Inputs.Comments,
            status: ApproveRejectStatus,
            empID: LoginInfo.employeeId
        }
        let URL = process.env.REACT_APP_PERMIT + "/Master/UpdateApproval?PermitNumber=" + permitNumber
        axios.put(URL, data).then((Res) => {
            if (Res.data === "Permit-Approved") {
                setVisibleDialog(!visibleDialog);
                ApproveCommentsForm.resetFields()
                toast.success("Permit Approved")
                Navigate("/ViewApprovalPage");
            } else if (Res.data === "Permit-Rejected") {
                setVisibleDialog(!visibleDialog);
                ApproveCommentsForm.resetFields()
                toast.error("Permit Rejected")
                Navigate("/ViewApprovalPage");
            } else {
                setLoaderHiden(false);
                setVisibleDialog(!visibleDialog);
                ApproveCommentsForm.resetFields()
                toast.error(Res.data)
            }
        }).catch((Error) => {
            console.log(Error, "Error GetNatureofwork")
        })
    };

    const ExtensionComment = () => {
        setLoaderHiden(true);
        let permitNumber = "";
        permitNumber = ExportPermitImgDetail.permitNumber;
        let Inputs = {}
        Inputs = ExtensionCommentsForm.getFieldsValue()
        let data = {
            approverLevel: state.approvalLevel,
            remarks: Inputs.Comments,
            status: ApproveExtensionStatus,
            empID: LoginInfo.employeeId
        }
        debugger;
        let URL = process.env.REACT_APP_PERMIT + "/Master/ExtensionUpdateApproval?PermitNumber=" + permitNumber
        axios.put(URL, data).then((Res) => {
            debugger
            if (Res.data === "Permit-Approved") {
                setVisibleExtensionDialog(!visibleExtensionDialog);
                ExtensionCommentsForm.resetFields()
                toast.success("Extension Approved")
                Navigate("/ExtensionApprovalPage");
            } else {
                setLoaderHiden(false);
                setVisibleExtensionDialog(!visibleExtensionDialog);
                ExtensionCommentsForm.resetFields()
                toast.error(Res.data)
            }
        }).catch((Error) => {
            console.log(Error, "Error GetNatureofwork")
        })
    };

    const toggleDialogClose = () => {
        setVisibleDialog(!visibleDialog);
    };

    const extensionDialogClose = () => {
        setVisibleExtensionDialog(!visibleExtensionDialog)
    }

    const ViewActiveClick = () => {
        if (ViewActiveIcon === false) {
            setViewActiveIcon(true)
        } else {
            setViewActiveIcon(false)
        }

    }

    const UpdatePermit = (data) => {
        Navigate("/PermitApproverMaster", { state: data });
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'row', height: '100%' }}>

            <div className='ActivityFabButton'>
                <FloatButton onClick={ViewActiveClick} style={{ top: "80%" }} />
            </div>
            <Tooltip title="Back" style={{ backgroundColor: "#ff4d4f" }}>
                <FloatButton type='primary' style={{ margin: "0% -1% 32% 0%" }} onClick={() => RevertViewPermit()} icon={<LeftOutlined />} />
            </Tooltip>
            {pathname === "/PermitApprovePage" &&
                <Tooltip title="Back" style={{ backgroundColor: "#ff4d4f" }}>
                    <FloatButton type='primary' style={{ margin: "0% -1% 32% 0%" }} onClick={() => RevertViewApproval()} icon={<LeftOutlined />} />
                </Tooltip>
            };
            {pathname === "/ExtensionApprovePage" &&
                <Tooltip title="Back" style={{ backgroundColor: "#ff4d4f" }}>
                    <FloatButton type='primary' style={{ margin: "0% -1% 32% 0%" }} onClick={() => RevertExtensionApproval()} icon={<LeftOutlined />} />
                </Tooltip>
            }

            {!ViewActiveIcon &&
                <>
                    <div className='PermitViewClass mainScroll'>
                        <div className='HreaderClass'>
                            <h5 className="Heading"> {ExportPermitImgDetail?.permitType} - {ExportPermitImgDetail?.permitNumber} </h5>
                        </div>
                        <Form form={PermitBasicInsertForm} layout="vertical" style={{ borderBottom: "1px solid", color: "black", paddingBottom: "1%" }} >
                            <div className="row">
                                <div className="col-md-3 col-sm-12">
                                    <div className="FormCard">
                                        <div>
                                            <label style={{ fontWeight: "bold" }}>Plant :</label><br />
                                            <label >{ExportBasicDetail?.plant}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-12">
                                    <div className="FormCard">
                                        <div>
                                            <label style={{ fontWeight: "bold" }} >Area :</label><br />
                                            <label >{ExportBasicDetail?.area}</label>
                                        </div>
                                    </div>
                                </div>

                                {ExportBasicDetail?.mentionArea && (
                                    <div className="col-md-3 col-sm-12">
                                        <div className="FormCard">
                                            <div>
                                                <label style={{ fontWeight: "bold" }}>Mention Area :</label><br />
                                                <label>{ExportBasicDetail?.mentionArea}</label>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="col-md-3 col-sm-12">
                                    <div className="FormCard">
                                        <div>
                                            <label style={{ fontWeight: "bold" }}  >Employee Name :</label><br />
                                            <label  >{ExportBasicDetail?.name}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-12">
                                    <div className="FormCard">
                                        <div>
                                            <label style={{ fontWeight: "bold" }} >Department :</label><br />
                                            <label>{ExportBasicDetail?.departmentName}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-12">
                                    <div className="FormCard">
                                        <div>
                                            <label style={{ fontWeight: "bold" }}>Contractor Name :</label><br />
                                            <label>{ExportBasicDetail?.nameofEmployee}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-12">
                                    <div className="FormCard">
                                        <div>
                                            <label style={{ fontWeight: "bold" }}>Permit Date :</label><br />
                                            {ExportBasicDetail?.issueDate &&
                                                <label>{format(parseISO(ExportBasicDetail?.issueDate), "dd/MM/yyyy")}</label>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-12">
                                    <div className="FormCard">
                                        <div>
                                            <label style={{ fontWeight: "bold" }}>Permit Start Time :</label><br />
                                            {ExportBasicDetail?.issueStartTime &&
                                                <label>{format(parseISO(ExportBasicDetail?.issueStartTime), "HH:mm")}</label>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-12">
                                    <div className="FormCard">
                                        <div>
                                            <label style={{ fontWeight: "bold" }}>Permit End Time :</label><br />
                                            {ExportBasicDetail?.issueEndTime &&
                                                <label>{format(parseISO(ExportBasicDetail?.issueEndTime), "HH:mm")}</label>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-12">
                                    <div className="FormCard">
                                        <div>
                                            <label style={{ fontWeight: "bold" }} >Number Of Persons :</label><br />
                                            <label>{ExportBasicDetail?.numberofPersons}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-12">
                                    <div className="FormCard">
                                        <div>
                                            <label style={{ fontWeight: "bold" }} >Name Of Persons :</label><br />
                                            <label>{ExportBasicDetail?.nameofPersons}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-12">
                                    <div className="FormCard">
                                        <div>
                                            <label style={{ fontWeight: "bold" }} >Description Of Work :</label><br />
                                            <label>{ExportBasicDetail?.jobDescription}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form>
                        <Form form={PermiMasterInsertForm}>
                            {PermitMasterData?.length > 0 && PermitMasterData?.map((item, index) =>

                                <div style={{ borderBottom: "1px solid black", marginLeft: "0%", width: "100%" }} className='row' key={"P_" + index}>
                                    <div className='col-md-9'>
                                        <div ><b>{index + 1}. </b>{item.title}</div>
                                        <div className='row'>
                                            {item.children !== undefined &&
                                                item.children.map((C_item, c_index) => <div className={`col-md-4`} key={"CH_" + c_index + index}>

                                                    {C_item.type === "string" && <div>
                                                        <div className="FormCard col-md-6">
                                                            <Form.Item label={C_item.title} name={C_item.title}>
                                                                <Input style={{ width: "100%", backgroundColor: "white", color: "black" }} defaultValue={C_item.value} disabled />
                                                            </Form.Item>
                                                        </div>
                                                    </div>}
                                                    {C_item.type === "bool" && <div>
                                                        <div className="FormCard col-md-6 flex flex-col">
                                                            <Form.Item name={C_item.title}>
                                                                <Checkbox checked={C_item.value}>{C_item.title}</Checkbox>
                                                            </Form.Item>
                                                        </div>
                                                    </div>}
                                                    {C_item.type === "dropdown" && <div>
                                                        <div className="FormCard col-md-6">
                                                            <Form.Item label={C_item.title} name={C_item.title}>
                                                                <Input style={{ width: "100%", backgroundColor: "white", color: "black" }} defaultValue={C_item.value} disabled />
                                                            </Form.Item>
                                                        </div>
                                                    </div>}
                                                </div>)}
                                        </div>
                                    </div>
                                    <div className='col-md-3' style={{ paddingTop: "2px" }} >
                                        <div className='row'>
                                            {item.type === "string" && <div>
                                                <div className="FormCard col-md-12">
                                                    <Form.Item name={item.title}>
                                                        <Input style={{ width: "150px", backgroundColor: "white", color: "black" }} defaultValue={item.value} disabled />
                                                    </Form.Item>
                                                </div>
                                            </div>}
                                            {item.type === "text" && <div>
                                                <div className="FormCard col-md-6">
                                                    <Form.Item name={item.title} rules={[{ required: false, message: "Enter Value" }]}>
                                                        <TextArea style={{ width: "100%", background: "white", color: "black" }} defaultValue={item.value} disabled />
                                                    </Form.Item>
                                                </div>
                                            </div>}
                                            {item.type === "bool" && <div>
                                                <div className="FormCard col-md-12 flex flex-col" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                    {item.children !== undefined && item.children.length > 0 ?
                                                        ""
                                                        :
                                                        <Form.Item name={item.title}>
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <div><a>Yes</a> <Switch checked={item.value} defaultChecked size="small" /> <a> No</a></div>
                                                            </div>
                                                        </Form.Item>
                                                    }
                                                    <Form.Item name={item.title}>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <Checkbox
                                                                checked={item.isApplicable} defaultChecked
                                                                style={{ marginLeft: '10px' }}
                                                            >
                                                                NA
                                                            </Checkbox>
                                                        </div>
                                                    </Form.Item>
                                                </div>
                                            </div>}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Form><br />

                        <div className='row' style={{ marginBottom: "1%", display: "flex" }}>
                            {PermitImageDatas?.length > 0 ?
                                <h4 style={{ textAlign: "center", color: "black" }}>Area of Work Images</h4>
                                : ""}
                            {PermitImageDatas?.length > 0 && PermitImageDatas?.map((item, index) =>
                                <div className="row" style={{ width: "100px", margin: "10px" }} key={index}>

                                    <a download="AreaWorkImage.jpeg" href={"data:image/jpeg;base64," + item.image}>
                                        <img style={{ width: "100px", height: "100px" }} src={"data:image/jpeg;base64," + item.image}>
                                        </img>
                                    </a>
                                </div>)}
                        </div>

                        {pathname === "/PermitViewPage" &&
                            <>
                                {ExportExtentionDetail ?
                                    <div className="BorderLineClass1">
                                        <div className="col-md-12 Header3 ">
                                            Extention Details
                                        </div>
                                        <div className="col-md-12 col-sm-12">
                                            {
                                                ExportExtentionDetail?.extensionDate &&
                                                <p style={{ marginLeft: "1%", marginRight: "0%" }}>All the checks reviewed afresh & permit revalidated up to
                                                    &nbsp;<b>{format(parseISO(ExportExtentionDetail?.extensionDate), "HH:mm")}</b>
                                                    Hrs.,Date
                                                    <b> {format(parseISO(ExportExtentionDetail?.extensionDate), "dd/MM/yyyy")}</b>.
                                                </p>
                                            }
                                        </div>
                                    </div> :
                                    <>
                                        {isButtonVisible &&
                                            <>
                                                {!ExtentionView && ExportBasicDetail?.status !== "Closed" || ExportBasicDetail?.status !== "Auto - Closed" &&
                                                    <div className='row'>
                                                        <div className="col-md-12 col-sm-12" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                            <Button type="primary" onClick={() => ViewExtentionPage()}>Add Extension</Button>
                                                        </div>
                                                    </div>
                                                }
                                            </>
                                        }
                                    </>
                                }

                                {ExtentionView &&
                                    <>
                                        <Form form={ExtentionInsertForm} onFinish={() => ExtentionInsert()} layout="vertical" >
                                            <div className='card1'>
                                                <div className="row">
                                                    <div className="col-md-3 col-sm-12">
                                                        <div className="FormCard">
                                                            <Form.Item label="Add Entention Time" name={"AddEntentionTime"} rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Please Select Entention Time!',
                                                                }
                                                            ]}>
                                                                <TimePicker disabledHours={getDisabledHours} style={{ width: '100%' }} />
                                                            </Form.Item>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 col-sm-12">
                                                        <Form.Item className="FormButtonClass" >
                                                            <Button type="primary" danger onClick={() => BackToEntention()}>Cancel</Button>
                                                            <Button type="primary" htmlType="submit" style={{ marginLeft: '10px' }}>Submit</Button>
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            </div>
                                        </Form>
                                    </>
                                }

                                <br />
                                {ExportBasicDetail?.status === "Closed" || ExportBasicDetail?.status === "Auto - Closed" &&
                                    <div className='row' style={{ marginBottom: "2%", display: "flex" }}>
                                        {PermitFileImage?.length > 0 ?
                                            <h4 style={{ textAlign: "center", color: "black" }}>Permit System Format Image</h4>
                                            : ""}
                                        {PermitFileImage?.length > 0 && PermitFileImage?.map((item, index) =>
                                            <div className="row" style={{ margin: "10px", width: "100px" }} key={index}>
                                                <a download="SystemFormatPermit.jpeg" href={"data:image/jpeg;base64," + item.image}>
                                                    <img style={{ width: "100px", height: "100px" }} src={"data:image/jpeg;base64," + item.image}>
                                                    </img>
                                                </a>
                                            </div>)}
                                    </div>
                                }

                                <div className='row'>
                                    <div className='col-md-8'></div>
                                    <div className='col-md-4' style={{ textAlign: "end", marginLeft: "-3%" }}>
                                        {ExportBasicDetail?.approvalStatus === "Approved" &&
                                            ExportBasicDetail?.status !== "Closed" &&
                                            ExportBasicDetail?.status !== "Auto - Closed" && (
                                                <Button
                                                    style={{ marginRight: "3%", backgroundColor: "palevioletred" }}
                                                    onClick={ClosePermitStatus}
                                                    type="primary"
                                                >
                                                    Close Permit
                                                </Button>
                                            )}
                                        {/* {ExportBasicDetail?.approvalStatus === "Approved" ?
                                            <Button style={{ marginRight: "3%", backgroundColor: "palevioletred" }} onClick={ClosePermitStatus} type="primary">Close Permit</Button> : ""} */}
                                        <Button style={{ marginRight: "3%" }} onClick={() => ViewExportToPermit()} type="primary" >View Export</Button>
                                    </div>
                                </div>
                            </>
                        }

                        {pathname === "/PermitApprovePage" &&
                            <div className='row'>
                                <div className='col-md-12 col-sm-12' style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <Button onClick={() => UpdatePermit("Edit")} type="primary" style={{ marginRight: "5px" }}>Edit</Button>
                                    <Button onClick={() => ApproveRejectSubmit("Approved")} type="primary" style={{ backgroundColor: "green", color: "white" }} >Approve</Button>
                                    <Button onClick={() => ApproveRejectSubmit("Rejected")} type="primary" style={{ marginLeft: "5px", backgroundColor: "red", color: "white" }}>Reject</Button>
                                </div>
                            </div>
                        }

                        {pathname === "/ExtensionApprovePage" &&
                            <div className='row'>
                                <div className='col-md-12 col-sm-12' style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <Button onClick={() => ExtensionApproveSubmit("Approved")} type="primary" style={{ marginRight: "5px" }}> Extension Approve</Button>
                                </div>
                            </div>
                        }

                        {visibleDialog &&
                            <Dialog title={"Please confirm"} onClose={toggleDialogClose} style={{ borderRadius: "3%" }}>
                                {ApproveRejectStatus === "Approved" ?
                                    <p style={{
                                        margin: "25px",
                                        textAlign: "center"
                                    }}>Are you sure want to Approve the Permit...!</p> :
                                    <p style={{
                                        margin: "25px",
                                        textAlign: "center"
                                    }}>Are you sure want to Reject the Permit...!</p>}
                                <Form form={ApproveCommentsForm} onFinish={ApproveComment}>
                                    <Form.Item name={"Comments"} rules={[
                                        {
                                            required: true,
                                            message: 'Please Enter Comments!',
                                        }
                                    ]}>
                                        <TextArea placeholder="Comments..." autoSize />
                                    </Form.Item>
                                    <Form.Item >
                                        <DialogActionsBar>
                                            <Button type='primary'
                                                onClick={toggleDialogClose}
                                                danger>Cancel</Button>
                                            {ApproveRejectStatus === "Approved" ?
                                                <Button type='primary' htmlType='submit'
                                                >Approve</Button> :
                                                <Button type='primary' htmlType='submit'
                                                >Reject</Button>}
                                        </DialogActionsBar>
                                    </Form.Item>
                                </Form>
                            </Dialog>}

                        {visibleExtensionDialog &&
                            <Dialog title={"Please confirm"} onClose={extensionDialogClose} style={{ borderRadius: "3%" }}>
                                <p style={{
                                    margin: "25px",
                                    textAlign: "center"
                                }}>Are you sure want to Approve the Permit for Extension...!</p>
                                <Form form={ExtensionCommentsForm} onFinish={ExtensionComment}>
                                    <Form.Item name={"Comments"} rules={[
                                        {
                                            required: true,
                                            message: 'Please Enter Comments!',
                                        }
                                    ]}>
                                        <TextArea placeholder="Comments..." autoSize />
                                    </Form.Item>
                                    <Form.Item >
                                        <DialogActionsBar>
                                            <Button type='primary'
                                                onClick={extensionDialogClose}
                                                danger>Cancel</Button>
                                            <Button type='primary' htmlType='submit'
                                            >Approve</Button>
                                        </DialogActionsBar>
                                    </Form.Item>
                                </Form>
                            </Dialog>}

                        {closePermitDialog &&
                            <Dialog title={"Please confirm"} onClose={permitCloseDialog}>
                                <p style={{
                                    margin: "25px",
                                    textAlign: "center"
                                }}>Are you sure you want close the permit...!</p>
                                <Form form={PermitCloceForm} onFinish={ClosePermitRequest}>
                                    <Form.Item name={"AttachmentFile"} label={"Attachment File"} rules={[{ required: false, message: 'Attachment File is Required' }]} type="file">
                                        <Upload
                                            multiple={true}
                                            listType="picture-card"
                                            onRemove={onRemoveFile}
                                            onChange={(e) => onFileUplode(e)}
                                            fileList={FileLists}>
                                            <div>
                                                <UploadOutlined />
                                                <div style={{ marginTop: 8 }}>Upload</div>
                                            </div>
                                        </Upload>
                                    </Form.Item>
                                    <Form.Item >
                                        <DialogActionsBar>
                                            <Button type='primary'
                                                onClick={permitCloseDialog}
                                                danger>Cancel</Button>

                                            <Button disabled={LoaderHiden} type='primary' htmlType='submit'
                                            >Submit</Button> :
                                        </DialogActionsBar>
                                    </Form.Item>
                                </Form>
                            </Dialog>}
                    </div>

                    <div className='ActivityTimeLine'>
                        <div className='PermitViewClass ActivityScroll' style={{ flex: 1, overflow: 'auto' }}>
                            <div className="timeline">
                                <Tabs defaultActiveKey="1">
                                    <Tabs.TabPane tab="Activities" key="1">
                                        {ExportPermitActivity?.length > 0 && ExportPermitActivity?.map((item, index) => {
                                            let formattedDate;
                                            let createdAtISO;
                                            try {
                                                createdAtISO = new Date(item.createdAt).toISOString();
                                                formattedDate = format(parseISO(item.createdAt), "MMMM dd, yyyy HH:mm");
                                            } catch (error) {
                                                console.error("Error parsing date:", error);
                                                formattedDate = "Invalid date";
                                            }
                                            return (
                                                <div className="tl-content tl-content-active" key={index}>
                                                    <div className="tl-header">
                                                        <span className="tl-marker"></span>
                                                        <p className="tl-title">{item.createdByName}</p>
                                                        <time className="tl-time" dateTime={createdAtISO}>
                                                            {formattedDate}
                                                        </time>
                                                    </div>
                                                    <div className="tl-body">
                                                        <p>{item.content}</p>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        <div style={{ with: "100%", marginTop: "10%" }}>
                                            <Input.TextArea
                                                value={inputValue}
                                                onChange={handleInputChange}
                                                rows={2}
                                                placeholder="Add Comments..."
                                            />
                                            <Button
                                                disabled={inputValue === ""}
                                                type="primary"
                                                onClick={handleSubmit}
                                                style={{ marginTop: '2%', marginBottom: "2%", marginLeft: "60%" }}
                                            >
                                                Submit
                                            </Button>
                                        </div>
                                    </Tabs.TabPane>
                                    <Tabs.TabPane tab="Approval Flow" key="2">
                                        <div>
                                            {Object.keys(groupedData).map((approvalType) => (
                                                <div key={approvalType}>
                                                    <h2 className="table-header">{approvalType}</h2>
                                                    {groupedData[approvalType].map((item, index) => (
                                                        <div className="tl-content tl-content-active" key={index}>
                                                            <div className="tl-header">
                                                                <span className={item.status === 'Approved' ? 'tl-marker' : 'tl-marker-pending'}></span>
                                                                <p>
                                                                    {item.status === "Approved" ? (
                                                                        <span className='tl-title'>
                                                                            {`${item.approvedByEmpID} - ${item.approvedByName}`}
                                                                        </span>
                                                                    ) : (
                                                                        <span className='tl-title'>
                                                                            {`${item.approvallBy}`}
                                                                        </span>
                                                                    )}
                                                                </p>
                                                                <time className="tl-time">
                                                                    <a>Level</a> {item?.approvalLevel}
                                                                </time>
                                                            </div>
                                                            <div className={item.status === 'Approved' ? 'tl-body' : 'tl-body-pending'}>
                                                                <p>{item?.status}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ))}
                                        </div>
                                    </Tabs.TabPane>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </>
            }

            {ViewActiveIcon &&
                <div className='ActivityTimeLine1'>
                    <div className='PermitViewClass ActivityScroll' style={{ flex: 1, overflow: 'auto' }}>
                        <Tabs defaultActiveKey="1">
                            <Tabs.TabPane tab="Activities" key="1">
                                {ExportPermitActivity?.length > 0 && ExportPermitActivity?.map((item, index) => {
                                    let formattedDate;
                                    let createdAtISO;
                                    try {
                                        createdAtISO = new Date(item.createdAt).toISOString();
                                        formattedDate = format(parseISO(item.createdAt), "MMMM dd, yyyy HH:mm");
                                    } catch (error) {
                                        console.error("Error parsing date:", error);
                                        formattedDate = "Invalid date";
                                    }
                                    return (
                                        <div className="tl-content tl-content-active" key={index}>
                                            <div className="tl-header">
                                                <span className="tl-marker"></span>
                                                <p className="tl-title">{item.createdByName}</p>
                                                <time className="tl-time" dateTime={createdAtISO}>
                                                    {formattedDate}
                                                </time>
                                            </div>
                                            <div className="tl-body">
                                                <p>{item.content}</p>
                                            </div>
                                        </div>
                                    );
                                })}
                                <div style={{ with: "100%", marginTop: "10%" }}>
                                    <Input.TextArea
                                        value={inputValue}
                                        onChange={handleInputChange}
                                        rows={2}
                                        placeholder="Add Comments..."
                                    />
                                    <Button
                                        disabled={inputValue === ""}
                                        type="primary"
                                        onClick={handleSubmit}
                                        style={{ marginTop: '2%', marginBottom: "2%", marginLeft: "60%" }}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </Tabs.TabPane>
                            <Tabs.TabPane tab="Approval Flow" key="2">
                                <div>
                                    {Object.keys(groupedData).map((approvalType) => (
                                        <div key={approvalType}>
                                            <h2 className="table-header">{approvalType}</h2>
                                            {groupedData[approvalType].map((item, index) => (
                                                <div className="tl-content tl-content-active" key={index}>
                                                    <div className="tl-header">
                                                        <span className={item.status === 'Approved' ? 'tl-marker' : 'tl-marker-pending'}></span>
                                                        <p>
                                                            {item.status === "Approved" ? (
                                                                <span className='tl-title'>
                                                                    {`${item.approvedByEmpID} - ${item.approvedByName}`}
                                                                </span>
                                                            ) : (
                                                                <span className='tl-title'>
                                                                    {`${item.approvallBy}`}
                                                                </span>
                                                            )}
                                                        </p>
                                                        <time className="tl-time">
                                                            <a>Level</a> {item?.approvalLevel}
                                                        </time>
                                                    </div>
                                                    <div className={item.status === 'Approved' ? 'tl-body' : 'tl-body-pending'}>
                                                        <p>{item?.status}</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </Tabs.TabPane>
                        </Tabs>
                        {/* <div className="timeline">
                            <p className="tl-titleH1">
                                Activity
                            </p>
                            {ExportPermitActivity?.length > 0 && ExportPermitActivity?.map((item, index) => {
                                let formattedDate;
                                let createdAtISO;
                                try {
                                    createdAtISO = new Date(item.createdAt).toISOString();
                                    formattedDate = format(parseISO(item.createdAt), "MMMM dd, yyyy HH:mm");
                                } catch (error) {
                                    console.error("Error parsing date:", error);
                                    formattedDate = "Invalid date";
                                }
                                return (
                                    <div className="tl-content tl-content-active" key={index}>
                                        <div className="tl-header">
                                            <span className="tl-marker"></span>
                                            <p className="tl-title">{item.createdByName}</p>
                                            <time className="tl-time" dateTime={createdAtISO}>
                                                {formattedDate}
                                            </time>
                                        </div>
                                        <div className="tl-body">
                                            <p>{item.content}</p>
                                        </div>
                                    </div>
                                );
                            })}
                            <div style={{ with: "100%", marginTop: "15%" }}>
                                <Input.TextArea
                                    value={inputValue}
                                    onChange={handleInputChange}
                                    rows={2}
                                    placeholder="Add Comments..."
                                />
                                <Button
                                    disabled={inputValue === ""}
                                    type="primary"
                                    onClick={handleSubmit}
                                    style={{ marginTop: '2%', marginBottom: "2%", marginLeft: "70%" }}
                                >
                                    Submit
                                </Button>
                            </div>
                        </div> */}
                    </div>
                </div>
            }
            <div className="hiTeam">
                {LoaderHiden && <Loader />}
            </div>
        </div>


    )
}

export default PermitViewPage